/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfSupportMessageListedAdminDto } from '../models/Pagination1OfSupportMessageListedAdminDto';
import type { Pagination1OfSupportMessageListedClientDto } from '../models/Pagination1OfSupportMessageListedClientDto';
import type { Pagination1OfSupportMessageListedDriverDto } from '../models/Pagination1OfSupportMessageListedDriverDto';
import type { PostSupportMessageAdminRequest } from '../models/PostSupportMessageAdminRequest';
import type { PostSupportMessageClientRequest } from '../models/PostSupportMessageClientRequest';
import type { PostSupportMessageToAdminDriverRequest } from '../models/PostSupportMessageToAdminDriverRequest';
import type { PostSupportMessageToClientRequest } from '../models/PostSupportMessageToClientRequest';
import type { RoleType } from '../models/RoleType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportMessagesService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static sendMessageToAdminDriver({
        requestBody,
    }: {
        requestBody?: PostSupportMessageToAdminDriverRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/supportmessages/admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static sendMessageToClientDriver({
        requestBody,
    }: {
        requestBody?: PostSupportMessageToClientRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/supportmessages/client',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static setSupportMessageAsReadDriver({
        senderUserId,
    }: {
        senderUserId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/supportmessages/{senderUserId}/read',
            path: {
                'senderUserId': senderUserId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfSupportMessageListedDriverDto OK
     * @throws ApiError
     */
    public static getSupportMessagesDriver({
        senderUserRoleType,
        senderUserId,
        isRead,
        page,
        limit,
    }: {
        senderUserRoleType: RoleType,
        senderUserId?: string,
        isRead?: boolean,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfSupportMessageListedDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/supportmessages',
            query: {
                'senderUserRoleType': senderUserRoleType,
                'senderUserId': senderUserId,
                'isRead': isRead,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static sendMessageToDriverClient({
        requestBody,
    }: {
        requestBody?: PostSupportMessageClientRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/supportmessages',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfSupportMessageListedClientDto OK
     * @throws ApiError
     */
    public static getSupportMessagesClient({
        senderUserId,
        page,
        limit,
    }: {
        senderUserId: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfSupportMessageListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/supportmessages',
            query: {
                'senderUserId': senderUserId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static setSupportMessageAsReadClient({
        senderUserId,
    }: {
        senderUserId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/supportmessages/{senderUserId}/read',
            path: {
                'senderUserId': senderUserId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSupportMessages`
     * @returns Pagination1OfSupportMessageListedAdminDto OK
     * @throws ApiError
     */
    public static getAllSupportMessagesAdmin({
        isRead,
        page,
        limit,
    }: {
        isRead?: boolean,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfSupportMessageListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/supportmessages/all',
            query: {
                'isRead': isRead,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSupportMessages`
     * @returns Pagination1OfSupportMessageListedAdminDto OK
     * @throws ApiError
     */
    public static getSupportMessagesByServantUserIdAdmin({
        driverUserId,
        page,
        limit,
    }: {
        driverUserId?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfSupportMessageListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/supportmessages/direct',
            query: {
                'driverUserId': driverUserId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSupportMessage`
     * @returns any OK
     * @throws ApiError
     */
    public static setSupportMessageAsReadAdmin({
        senderUserId,
    }: {
        senderUserId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/supportmessages/{senderUserId}/read',
            path: {
                'senderUserId': senderUserId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSupportMessage`
     * @returns any OK
     * @throws ApiError
     */
    public static postDriverMessageAdmin({
        requestBody,
    }: {
        requestBody?: PostSupportMessageAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/supportmessages/driver/message',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
